<script setup lang="ts">
import { ref, watch, Ref } from 'vue';
import { throttle } from 'lodash';
import { SeriesObjectType } from '@/components/charts/utils/utils.types';
import { ChartTypes } from '@/components/Common/graph.types';

interface Props {
  chartOptions: object;
  series: SeriesObjectType[];
  type?: ChartTypes;
  height?: string;
}

const emit = defineEmits(['onMouseMove']);
const props = withDefaults(defineProps<Props>(), {});
const chart: any = ref(null);
defineExpose({
  chart,
});

const onMove = throttle(function (_event, _chartContext, config) {
  if (config.dataPointIndex >= 0) {
    const dataPoint = props.series?.map((obj) => {
      return {
        y: obj.data[config.dataPointIndex]?.y,
        x: obj.data[config.dataPointIndex]?.x,
      };
    });
    emit('onMouseMove', dataPoint);
  }
}, 100);
</script>

<template>
  <apexchart
    ref="chart"
    height="100%"
    width="100%"
    :type="props.type"
    :options="props.chartOptions"
    :series="props.series"
    @mouseMove="onMove"
  ></apexchart>
</template>

<style scoped></style>
